module.exports = __webpack_public_path__ + "media/typy/dostawcze@2x-aa330611.png";